import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RequestReceivedModalPageRoutingModule } from './request-received-modal-routing.module';

import { RequestReceivedModalPage } from './request-received-modal.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RequestReceivedModalPageRoutingModule,
    ComponentsModule,
  ],
  declarations: [RequestReceivedModalPage],
})
export class RequestReceivedModalPageModule {}
